import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController,ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { FileOpener } from '@ionic-native/file-opener';
import {File} from "@ionic-native/file";
import {FileTransfer,FileUploadOptions, FileTransferObject} from "@ionic-native/file-transfer";
import {DashboardHomePage} from "../dashboard-home/dashboard-home";
import {AndroidPermissions} from "@ionic-native/android-permissions";


//@IonicPage()
@Component({
  selector: 'page-nonenquirylog',
  templateUrl: 'nonenquirylog.html',
})

export class NonenquirylogPage {

  calllogs:any[];

  constructor(public navCtrl: NavController, public navParams: NavParams,public service:ServiceProvider,public viewCtrl:ViewController,
              public loadingCtrl:LoadingController,public file:File,private fileOpener:FileOpener,public fileTransfer:FileTransfer,
              private androidPermissions: AndroidPermissions) {
    this.getcalllogs();
    this.checkPermission();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NonenquirylogPage');
  }

  getcalllogs()
  {
    let loading=this.loadingCtrl.create({
      content:"Loading Logs..."
    });

    loading.present();

    setTimeout(()=>{
      loading.dismiss();
    },10000);

    this.service.httppostcall("web_service/get_nonenquiry_log",'').subscribe(data=>{
      loading.dismiss();
      console.log(data);
      this.calllogs=data['data'];
    });
  }


  playaudio(fileurl,filename)
  {

    /*Create Folder*/
    this.file.checkDir(this.file.externalRootDirectory, 'ApplusDownload').then(response =>
    {
      console.log('Directory exists'+response);
    }).catch(err => {
      console.log('Directory doesn\'t exist'+JSON.stringify(err));
      this.file.createDir(this.file.externalRootDirectory, 'ApplusDownload', false).then(response => {
        console.log('Directory create'+response);
      }).catch(err => {
        console.log('Directory no create'+JSON.stringify(err));
      });
    });

    /*Create Folder*/

    let path=this.file.externalRootDirectory+'ApplusDownload/'+filename;

    console.log(path);

    this.file.resolveLocalFilesystemUrl(path).then((entry: any) => {
      entry.file((file1) =>
      {
        this.openAudioFromStorage(path);
        console.log(file1);
      })
    }).catch((error) =>
    {
      console.log(error);
      this.downloadCall(fileurl,filename,path);
    });



    //this.openAudioFromStorage('');


  }

  downloadCall(fileurl,filename,path)
  {

    let loading=this.loadingCtrl.create({
      content:'Downloading Recording Please Wait...'
    });

    loading.present();

    setTimeout(()=>{
      loading.dismiss();
    },10000)

    const fileTransfer: FileTransferObject = this.fileTransfer.create();

    fileTransfer.download(fileurl, this.file.externalRootDirectory+'ApplusDownload/'+filename).then((entry) => {
      console.log('download complete: ' + entry.toURL());
      loading.dismiss();
      this.openAudioFromStorage(path);
    }, (err) => {
      // handle error
      console.log('Error',err);
      loading.dismiss();
    });
  }

  openAudioFromStorage(path)
  {
    this.fileOpener.open(path, 'audio/mpeg')
        .then(() => console.log('File is opened'))
        .catch(e => console.log('Error opening file', e));
  }


  dismiss()
  {
    // this.viewCtrl.dismiss();
    this.navCtrl.setRoot(DashboardHomePage);
  }

  checkPermission()
  {
    console.log("Check Permission");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(result => {
          //this.hasPermission = result.hasPermission;
          console.log('Has permission?', result['hasPermission']);
          if (result['hasPermission']) {
            console.log("Has Permission");
          } else {
            console.log("Deny Permission");
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
              console.log(result_data);
              if (result_data['hasPermission']) {
                console.log('Storage allow ', result_data['hasPermission']);
              } else {
                console.log('Storage deny ', result_data['hasPermission']);
              }
            }).catch((err) => {
              console.log("catch loop",JSON.stringify(err));
            });
          }
        },
        err => {
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
            console.log(result_data);
            console.log('error Has permission?', result_data['hasPermission']);
            if (result_data['hasPermission']) {
              console.log('err Storage allow ', result_data['hasPermission']);
            } else {
              console.log('err Storage deny ', result_data['hasPermission']);
            }
          }).catch((err) => {
            console.log(JSON.stringify(err));
          });
        });

  }

}



// WEBPACK FOOTER //
// ./src/pages/nonenquirylog/nonenquirylog.ts